import React from 'react'
import { Col, Row } from 'reactstrap'
import { BiSolidRightArrow } from 'react-icons/bi'
import {  Facebook, GeoAltFill, Instagram, TelephoneFill, Tiktok, Youtube } from 'react-bootstrap-icons'
import { MdEmail } from 'react-icons/md'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <div id='website-responsive'>
        <div className='bg-img-footer display-none footer-padding' style={{ backgroundImage:"url('footer/Footer-Background-v1-United-Lab-Care.png')" ,height:'auto', width:'100%', }}>
            <div className='pb-2 pt-'>
                <img src='logo/United-Lab-Care-Logo-1536x281.png' alt='' height='auto' width='280px' className='' /> 
            </div>  

            <div className='py-3 display-none-991'>
                <div className='fs-ss-17 fw-600 text-ss-black'>
                    Comprehensive RSV / Influenza / Respiratory Pathogen Panel and<br/>
                    COVID-19 Testing Solutions for Individuals, Businesses and Institutions.
                </div>
            </div>

            <div className='pt-2 pb-md4'>
                <Row className=''>
                    <Col md='4' className=''>
                        <div className=''>
                            <div className=''>
                                <div className='fs-ss-20 text-montserrat fw-700 text-ss-black mb-3' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    Quick Links
                                </div>
                                <Link to='/about' style={{ textDecoration:'none'}}>
                                <div className='fs-ss-15 text-montserrat fw-500 text-hover-blue text-ss-black mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                        
                                    <BiSolidRightArrow className='fs-ss-12'/> About
                                </div>
                                </Link>
                                
                                <Link to='/services' style={{ textDecoration:'none'}}>
                                <div className='fs-ss-15 text-montserrat fw-500 text-hover-blue text-ss-black mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <BiSolidRightArrow className='fs-ss-12'/> Panel Testing
                                </div>
                                </Link>

                                <Link to='/covid-and-rt-pcr-test-in-chicago-il' style={{ textDecoration:'none'}}>
                                <div className='fs-ss-15 text-montserrat fw-500 text-hover-blue text-ss-black mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <BiSolidRightArrow className='fs-ss-12'/> Covid Testing
                                </div>
                                </Link>
                            </div>
                        </div>
                    </Col>
                    <Col md='6' className=''>
                        <div className=''>
                            <div className=''>
                                <div className='fs-ss-20 text-montserrat fw-700 text-ss-black mb-3' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    Get in Touch
                                </div>
                                <a href='tel: (800) 442-1663' target='_blank' rel='noreferrer' style={{ textDecoration:'none'}} >
                                <div className='fs-ss-15 text-montserrat fw-500 text-hover-blue text-ss-black mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <TelephoneFill className='fs-ss-18 me-2'/> (800) 442-1663
                                </div>
                                </a>

                                <a href='mailto: info@unitedlabcare.com' target='_blank' rel='noreferrer' style={{ textDecoration:'none'}} >
                                <div className='fs-ss-15 text-montserrat fw-500 text-hover-blue text-ss-black mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <MdEmail className='fs-ss-18 me-2'/> info@unitedlabcare.com
                                </div>
                                </a>

                                <a href='https://www.google.com/maps/dir//246+E+Janata+Blvd+%23115,+Lombard,+IL+60148,+USA/@41.8443139,-88.0123582,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x880e527567ae7583:0x203fa4f7e86dc0f9!2m2!1d-88.0123582!2d41.8443139?entry=ttu' target='_blank' rel='noreferrer' style={{ textDecoration:'none'}} >                                
                                <div className='fs-ss-15 text-montserrat text-hover-blue fw-500 text-ss-black mb-2 d-flex justify-content-start' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <GeoAltFill className='fs-ss-18 me-2'/> 246 E Janata Blvd # 115, Lombard, 60148
                                </div>
                                </a>
                            </div>
                        </div>
                    </Col>

                    {/* <Col md='4' className=''>
                        <div className=''>
                            <div className=''>
                                <div className='fs-ss-20 text-montserrat fw-700 text-ss-black mb-3' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    Useful Links
                                </div>
                                <Link to='/about' style={{ textDecoration:'none'}}>
                                <div className='fs-ss-15 text-montserrat fw-500 text-hover-blue text-ss-black mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                        
                                    <BiSolidRightArrow className='fs-ss-12'/> Symptoms
                                </div>
                                </Link>
                                
                                <Link to='/services' style={{ textDecoration:'none'}}>
                                <div className='fs-ss-15 text-montserrat fw-500 text-hover-blue text-ss-black mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <BiSolidRightArrow className='fs-ss-12'/> WHO Advice
                                </div>
                                </Link>

                                <Link to='/covid-and-rt-pcr-test-in-chicago-il' style={{ textDecoration:'none'}}>
                                <div className='fs-ss-15 text-montserrat fw-500 text-hover-blue text-ss-black mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <BiSolidRightArrow className='fs-ss-12'/> CDC Website
                                </div>
                                </Link>

                                <Link to='/covid-and-rt-pcr-test-in-chicago-il' style={{ textDecoration:'none'}}>
                                <div className='fs-ss-15 text-montserrat fw-500 text-hover-blue text-ss-black mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <BiSolidRightArrow className='fs-ss-12'/> WorldOMeter USA
                                </div>
                                </Link>

                                <Link to='/covid-and-rt-pcr-test-in-chicago-il' style={{ textDecoration:'none'}}>
                                <div className='fs-ss-15 text-montserrat fw-500 text-hover-blue text-ss-black mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <BiSolidRightArrow className='fs-ss-12'/> CoronaVirus Illinois
                                </div>
                                </Link>

                                <Link to='/covid-and-rt-pcr-test-in-chicago-il' style={{ textDecoration:'none'}}>
                                <div className='fs-ss-15 text-montserrat fw-500 text-hover-blue text-ss-black mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <BiSolidRightArrow className='fs-ss-12'/> CDC Quarantine and Isolation
                                </div>
                                </Link>

                                <Link to='/covid-and-rt-pcr-test-in-chicago-il' style={{ textDecoration:'none'}}>
                                <div className='fs-ss-15 text-montserrat fw-500 text-hover-blue text-ss-black mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <BiSolidRightArrow className='fs-ss-12'/> CDC Website
                                </div>
                                </Link>
                            </div>
                        </div>
                    </Col> */}

                    <Col className='me-lg-5 me-md-4 dflex' style={{ marginTop:'-2rem', }}>
                        <div className='pb-3 flex-center10' style={{ cursor:'pointer'}}>
                        <a href='https://www.facebook.com/unitedlabcare' target='_blank' className='' style={{ textDecoration:'none'}}>
                            <Facebook className='fs-ss-24 text-ss-primary'/>
                            </a>
                        </div>
                        <div className='pb-3 flex-center10' style={{ cursor:'pointer'}}>
                        <a href='https://www.instagram.com/unitedlabcare/' target='_blank' className='' style={{ textDecoration:'none'}}>
                            <Instagram className='fs-ss-24 text-ss-black'/>
                            </a>
                        </div>
                        <div className='pb-3 flex-center10' style={{ cursor:'pointer'}}>
                        <a href='https://www.youtube.com/@unitedlabcare' target='_blank' className='' style={{ textDecoration:'none'}}>
                            <Youtube className='fs-ss-24' style={{ color:'#cd201f'}}/>
                        </a>
                        </div>
                        <div className='pb-3 flex-center10' style={{ cursor:'pointer'}}>
                        <a href='https://www.tiktok.com/@unitedlabcare' target='_blank' className='' style={{ textDecoration:'none'}}>
                            <Tiktok className='fs-ss-24' style={{ color:'#69727d'
                           }}/>
                        </a>
                        </div>

                        <div className='flex-center10 me-2' style={{ borderRight:'2px solid #B7B7B7', height:'70px'}}>

                        </div>
                    </Col>
                </Row>
            </div>  
        </div>

        {/* Mobile Footer */}
        <div className='bg-img-footer display-block1' style={{ backgroundColor:'#2076ad', padding:'1.5rem',
        borderBottom:'1px solid white'}}>
            <div className='pb-4 d-flex justify-content-center'>
                <img src='logo/United-Lab-Care-Mobile-Footer-Logo-v1.png' alt='' height='auto' width='45%' className='' /> 
            </div>  

            <div className='py-3 pe-5'>
                <div className='fs-ss-15 fw-600 text-white'>
                    Comprehensive RSV / Influenza / Respiratory Pathogen Panel and
                    COVID-19 Testing Solutions for Individuals, Businesses and Institutions.
                </div>
            </div>

            <div className='pt-2 pb-md4'>
                <Row className=''>
                    <Col md='12' className=''>
                        <div className=''>
                            <div className='my-3'>
                                <div className='fs-ss20 text-montserrat fw-700 text-white mb-3' style={{ letterSpacing:'0.5px', fontSize:'22px', cursor:'pointer'}}>
                                    Quick Links
                                </div>
                                <div className='mb-3'>
                                <hr className='hr-style-white mymd-2' style={{ width:'80px', marginTop:'px', marginBottom:'4px', }}/>
                                </div>
                                <Link to='/about' style={{ textDecoration:'none'}}>
                                <div className='fs-ss-15 text-montserrat fw-500  text-white mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                        
                                    <BiSolidRightArrow className='fs-ss-12'/> About
                                </div>
                                </Link>
                                
                                <Link to='/services' style={{ textDecoration:'none'}}>
                                <div className='fs-ss-15 text-montserrat fw-500  text-white mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <BiSolidRightArrow className='fs-ss-12'/> Panel Testing
                                </div>
                                </Link>

                                <Link to='/covid-and-rt-pcr-test-in-chicago-il' style={{ textDecoration:'none'}}>
                                <div className='fs-ss-15 text-montserrat fw-500  text-white mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <BiSolidRightArrow className='fs-ss-12'/> Covid Testing
                                </div>
                                </Link>
                            </div>
                        </div>
                    </Col>
                    <Col md='12' className=''>
                        <div className=''>
                            <div className='my-3'>
                                <div className='fs-ss20 text-montserrat fw-700 text-white mb-3' style={{ letterSpacing:'0.5px', fontSize:'22px', cursor:'pointer'}}>
                                    Get in Touch
                                </div>
                                <div className='mb-3'>
                                <hr className='hr-style-white mymd-2' style={{ width:'80px', marginTop:'px', marginBottom:'4px', }}/>
                                </div>
                                <a href='tel: (800) 442-1663' target='_blank' rel='noreferrer' style={{ textDecoration:'none'}} >
                                <div className='fs-ss-15 text-montserrat fw-500  text-white mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <TelephoneFill className='fs-ss-18 me-2'/> (800) 442-1663
                                </div>
                                </a>

                                <a href='mailto: info@unitedlabcare.com' target='_blank' rel='noreferrer' style={{ textDecoration:'none'}} >
                                <div className='fs-ss-15 text-montserrat fw-500  text-white mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <MdEmail className='fs-ss-18 me-2'/> info@unitedlabcare.com
                                </div>
                                </a>

                                <a href='https://www.google.com/maps/dir//246+E+Janata+Blvd+%23115,+Lombard,+IL+60148,+USA/@41.8443139,-88.0123582,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x880e527567ae7583:0x203fa4f7e86dc0f9!2m2!1d-88.0123582!2d41.8443139?entry=ttu' target='_blank' rel='noreferrer' style={{ textDecoration:'none'}} >                                
                                <div className='fs-ss-15 text-montserrat  fw-500 text-white mb-2 d-flex justify-content-start' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <GeoAltFill className='fs-ss-18 me-2'/> 246 E Janata Blvd # 115, Lombard, 60148
                                </div>
                                </a>
                            </div>
                        </div>
                    </Col>

                    <Col md='12' className=''>
                        <div className=''>
                            <div className='my-3'>
                                <div className='fs-ss20 text-montserrat fw-700 text-white mb-3' style={{ letterSpacing:'0.5px', fontSize:'22px', cursor:'pointer'}}>
                                    Useful Links
                                </div>
                                <div className='mb-3'>
                                <hr className='hr-style-white mymd-2' style={{ width:'80px', marginTop:'px', marginBottom:'4px', }}/>
                                </div>
                                <Link to='/about' style={{ textDecoration:'none'}}>
                                <div className='fs-ss-15 text-montserrat fw-500  text-white mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                        
                                    <BiSolidRightArrow className='fs-ss-12'/> Symptoms
                                </div>
                                </Link>
                                
                                <a href='https://www.who.int/emergencies/diseases/novel-coronavirus-2019/advice-for-public' target='_blank' rel='noreferrer' style={{ textDecoration:'none'}}>
                                <div className='fs-ss-15 text-montserrat fw-500  text-white mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <BiSolidRightArrow className='fs-ss-12'/> WHO Advice
                                </div>
                                </a>

                                <a href='https://www.cdc.gov/coronavirus/2019-ncov/index.html' target='_blank' rel='noreferrer' style={{ textDecoration:'none'}}>
                                <div className='fs-ss-15 text-montserrat fw-500  text-white mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <BiSolidRightArrow className='fs-ss-12'/> CDC Website
                                </div>
                                </a>

                                <a href='https://www.worldometers.info/coronavirus/country/us/' target='_blank' rel='noreferrer' style={{ textDecoration:'none'}}>
                                <div className='fs-ss-15 text-montserrat fw-500  text-white mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <BiSolidRightArrow className='fs-ss-12'/>  WorldOMeter USA
                                </div>
                                </a>

                                <a href='https://www.worldometers.info/coronavirus/country/us/' target='_blank' rel='noreferrer' style={{ textDecoration:'none'}}>
                                <div className='fs-ss-15 text-montserrat fw-500  text-white mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <BiSolidRightArrow className='fs-ss-12'/> CoronaVirus Illinois
                                </div>
                                </a>
                        

                                <a href='https://dph.illinois.gov/covid19.html' target='_blank' rel='noreferrer' style={{ textDecoration:'none'}}>
                                <div className='fs-ss-15 text-montserrat fw-500  text-white mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <BiSolidRightArrow className='fs-ss-12'/> CDC Quarantine and Isolation
                                </div>
                                </a>

                                
                            </div>
                        </div>
                    </Col>

                    <Col className='me-5 d-flex justify-content-center' style={{ marginTop:'1rem', }}>
                        <div className='pb-3 flex-center10' style={{ cursor:'pointer'}}>
                        <a href='https://www.facebook.com/unitedlabcare' target='_blank' className='' style={{ textDecoration:'none'}}>
                            <Facebook className='fs-ss-24-2 text-white mx-2 '/>
                            </a>
                        </div>
                        <div className='pb-3 flex-center10' style={{ cursor:'pointer'}}>
                        <a href='https://www.instagram.com/unitedlabcare/' target='_blank' className='' style={{ textDecoration:'none'}}>
                            <Instagram className='fs-ss-24-2 text-white mx-2'/>
                            </a>
                        </div>
                        <div className='pb-3 flex-center10' style={{ cursor:'pointer'}}>
                        <a href='https://www.youtube.com/@unitedlabcare' target='_blank' className='' style={{ textDecoration:'none'}}>
                            <Youtube className='fs-ss-24-2 text-white mx-2' style={{ color:'#'}}/>
                        </a>
                        </div>
                        <div className='pb-3 flex-center10' style={{ cursor:'pointer'}}>
                        <a href='https://www.tiktok.com/@unitedlabcare' target='_blank' className='' style={{ textDecoration:'none'}}>
                            <Tiktok className='fs-ss-24-2 text-white mx-2' style={{ color:'#'
                           }}/>
                        </a>
                        </div>

                        {/* <div className='flex-center10 me-2' style={{ borderRight:'2px solid #B7B7B7', height:'70px'}}>

                        </div> */}
                    </Col>
                </Row>
            </div>  
        </div>
    </div>
  )
}

export default Footer